import { PreviewImage } from '@plone/volto/components';

export const components = {
  PreviewImage: { component: PreviewImage },
};
